export default function PeriziaSection() {
  return (
    <section id="perizia" className="py-12 sm:py-16 lg:py-20 bg-gradient-to-b from-[#F8F9FA] to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-10 lg:gap-12 items-center">
          <div className="order-2 lg:order-1">
            <div className="relative rounded-lg overflow-hidden shadow-2xl">
              <div className="w-full h-[400px] sm:h-[500px] lg:h-[650px]">
                <img
                  src="https://public.readdy.ai/ai/img_res/c212a6517483c596cbd87d01721ad57a.jpg"
                  alt="Perizia Brand Patrimoniale"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>

          <div className="order-1 lg:order-2">
            <div className="inline-block px-4 py-2 bg-[#0B1F3B]/5 rounded-full mb-4 sm:mb-6">
              <span className="text-sm font-semibold text-[#0B1F3B]">Servizio Premium</span>
            </div>
            <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-bold text-[#0B1F3B] mb-4 sm:mb-6 leading-tight text-left">
              Perizia Brand Patrimoniale
            </h2>
            <p className="text-sm sm:text-base text-[#1C1C1C]/80 mb-4 sm:mb-5 leading-relaxed">
              Documento peritale conforme agli standard ISO 10668 per la valutazione monetaria del brand, difendibile a bilancio e utilizzabile per operazioni straordinarie.
            </p>
            <p className="text-sm sm:text-base text-[#1C1C1C]/70 mb-5 sm:mb-6 leading-relaxed">
              La perizia Brand Capital è redatta secondo principi contabili internazionali e metodologie riconosciute, garantendo piena validità per capitalizzazione a bilancio, accesso al credito, operazioni M&amp;A e pianificazione patrimoniale.
            </p>

            <div className="bg-white rounded-lg p-4 sm:p-5 border border-[#0B1F3B]/10 mb-5 sm:mb-6">
              <h4 className="text-sm sm:text-base font-semibold text-[#0B1F3B] mb-3 sm:mb-4">Conformità Normativa</h4>
              <div className="space-y-3">
                <div className="flex items-start gap-3">
                  <i className="ri-shield-check-line text-[#C9A861] text-lg mt-0.5"></i>
                  <div>
                    <p className="text-sm font-semibold text-[#0B1F3B]">Standard ISO 10668</p>
                    <p className="text-xs text-[#1C1C1C]/60">Valutazione monetaria del brand secondo normativa internazionale</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <i className="ri-shield-check-line text-[#C9A861] text-lg mt-0.5"></i>
                  <div>
                    <p className="text-sm font-semibold text-[#0B1F3B]">IAS 38 / IFRS</p>
                    <p className="text-xs text-[#1C1C1C]/60">Conformità principi contabili internazionali per attività immateriali</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <i className="ri-shield-check-line text-[#C9A861] text-lg mt-0.5"></i>
                  <div>
                    <p className="text-sm font-semibold text-[#0B1F3B]">OIC 24</p>
                    <p className="text-xs text-[#1C1C1C]/60">Principi contabili nazionali per immobilizzazioni immateriali</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="space-y-4 sm:space-y-5">
              <h4 className="text-sm sm:text-base font-semibold text-[#0B1F3B]">Applicazioni della Perizia</h4>
              
              <div className="space-y-3 sm:space-y-4">
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 flex items-center justify-center bg-[#0B1F3B]/5 rounded-lg flex-shrink-0">
                    <i className="ri-file-list-line text-lg text-[#0B1F3B]"></i>
                  </div>
                  <div>
                    <h5 className="text-sm font-semibold text-[#0B1F3B] mb-1">Capitalizzazione a Bilancio</h5>
                    <p className="text-sm text-[#1C1C1C]/70 leading-relaxed">
                      Iscrizione del brand come attività immateriale nel patrimonio aziendale
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 flex items-center justify-center bg-[#0B1F3B]/5 rounded-lg flex-shrink-0">
                    <i className="ri-bank-line text-lg text-[#0B1F3B]"></i>
                  </div>
                  <div>
                    <h5 className="text-sm font-semibold text-[#0B1F3B] mb-1">Accesso al Credito</h5>
                    <p className="text-sm text-[#1C1C1C]/70 leading-relaxed">
                      Miglioramento rating creditizio e garanzie per finanziamenti bancari
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 flex items-center justify-center bg-[#0B1F3B]/5 rounded-lg flex-shrink-0">
                    <i className="ri-exchange-line text-lg text-[#0B1F3B]"></i>
                  </div>
                  <div>
                    <h5 className="text-sm font-semibold text-[#0B1F3B] mb-1">Operazioni M&amp;A</h5>
                    <p className="text-sm text-[#1C1C1C]/70 leading-relaxed">
                      Valutazione difendibile per acquisizioni, fusioni e cessioni aziendali
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 flex items-center justify-center bg-[#0B1F3B]/5 rounded-lg flex-shrink-0">
                    <i className="ri-funds-box-line text-lg text-[#0B1F3B]"></i>
                  </div>
                  <div>
                    <h5 className="text-sm font-semibold text-[#0B1F3B] mb-1">Equity e Investimenti</h5>
                    <p className="text-sm text-[#1C1C1C]/70 leading-relaxed">
                      Documentazione per round di investimento e ingresso soci
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="mt-6 sm:mt-8 pt-5 sm:pt-6 border-t border-[#0B1F3B]/10">
              <a
                href="#contatti"
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-5 sm:px-6 py-3 bg-[#0B1F3B] text-white rounded-md text-sm sm:text-base font-semibold hover:bg-[#0B1F3B]/90 transition-all whitespace-nowrap cursor-pointer"
              >
                Richiedi Perizia Patrimoniale
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
